import { LucideProps } from 'lucide-react'

const GuaranteeGray = (props: LucideProps) => (
  <svg
    width="108"
    height="107"
    viewBox="0 0 108 107"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32.415 15.6016V100.993L53.607 88.6811L74.7246 100.993V15.6016H32.415Z"
      fill="#CEDAE3"
    />
    <path
      d="M53.5768 77.2865C73.6542 77.2865 89.9271 61.0136 89.9271 40.9362C89.9271 20.8589 73.6542 4.58594 53.5768 4.58594C33.4995 4.58594 17.2266 20.8589 17.2266 40.9362C17.2266 61.0136 33.4995 77.2865 53.5768 77.2865Z"
      fill="white"
    />
    <path
      d="M53.5768 77.2865C73.6542 77.2865 89.9271 61.0136 89.9271 40.9362C89.9271 20.8589 73.6542 4.58594 53.5768 4.58594C33.4995 4.58594 17.2266 20.8589 17.2266 40.9362C17.2266 61.0136 33.4995 77.2865 53.5768 77.2865Z"
      fill="#CEDAE3"
      fillOpacity="0.55"
    />
    <path
      d="M63.929 25.7722L48.7515 42.0469L56.2829 49.0706L71.4605 32.7959L63.929 25.7722Z"
      fill="white"
    />
    <path
      d="M42.7108 35.487L35.687 43.0195L49.7249 56.1092L56.7486 48.5767L42.7108 35.487Z"
      fill="white"
    />
  </svg>
)

export default GuaranteeGray
